import BaseApi from "./BaseApi";

export default class Dashboard extends BaseApi{
    construct() {}
    
    static async works(params) {
        let url = Dashboard.getFullApiUrl() + "works";

        return Dashboard.getAxiosInstance().get(url,{params: params});
    }

    static async worksCounters() {
        let url = Dashboard.getFullApiUrl() + "works/counters";

        return Dashboard.getAxiosInstance().get(url);
    }

    static async diariesCounters() {
        let url = Dashboard.getFullApiUrl() + "diaries/counters";

        return Dashboard.getAxiosInstance().get(url);
    }

    static async diaries(params) {
        let url = Dashboard.getFullApiUrl() + "diaries";

        return Dashboard.getAxiosInstance().get(url,{params: params});
    }

    static async getStatistics(params){
        let url = Dashboard.getFullApiUrl() + "statistics";
        
        return Dashboard.getAxiosInstance().get(url, {params: params});
    }


    static async workHand(params) {
        let url = Dashboard.getFullApiUrl() + "workhand";

        return Dashboard.getAxiosInstance().get(url,{params: params});
    }

    static async unit(params) {
        let url = Dashboard.getFullApiUrl() + "units";

        return Dashboard.getAxiosInstance().get(url,{params: params});
    }

    static async markTutorial(id){
        let url = Dashboard.getFullApiUrl() + id + '/mark-tutorial'

        return Dashboard.getAxiosInstance().post(url,{params: {} });
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/admin/dashboards/";
    }

    static getFullApiUrl(){
        let domain = location.pathname.split('/')[1]
        return BaseApi.getFullDomainApiUrl() + "api/" + domain + "/admin/dashboards/";
    }

    //\Route::name("admin.dashboards.statistics")->get("/", "Statistics");
}